import {
  useMutation,
  UseMutationOptions,
  UseMutationResult,
  useQueryClient,
} from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { axiosInstance } from '../../axios';
import { AdMutationResult, AdRequest, AdsApiResponse } from './types';
import { ADS_QUERY_KEY } from './useGetAds';

type MutationParams = { data: AdRequest };

/**
 * Zakłada reklamę w katalogu. Hotele z `assigned_hotels` widzą ją od razu —
 * filtrują katalog po tym polu, więc nic się nigdzie nie kopiuje.
 */
export const usePostAd = (
  options?: UseMutationOptions<AdMutationResult, AxiosError, MutationParams>,
): UseMutationResult<AdMutationResult, AxiosError, MutationParams> => {
  const queryClient = useQueryClient();

  return useMutation<AdMutationResult, AxiosError, MutationParams>({
    mutationFn: async ({ data }) => {
      const res = await axiosInstance.post<AdsApiResponse<AdMutationResult>>('/v3-createAd', data);
      return res.data.data;
    },
    ...options,
    onSuccess: (...args) => {
      queryClient.invalidateQueries({ queryKey: ADS_QUERY_KEY });
      options?.onSuccess?.(...args);
    },
  });
};
